module.exports = __webpack_public_path__ + "img/finance-icon-1.0e476d7d.svg";